import useSWR from 'swr';

export interface Permission {
  id: string;
  project_id?: string;
  project_slug?: string;
  user_email?: string;
  group_name?: string;
  role: 'reader' | 'developer' | 'maintainer' | 'project_admin' | 'org_admin';
}

const fetcher = (url: string) =>
  fetch(url, { credentials: 'include' }).then((r) => r.json());

export function usePermissions(projectId?: string) {
  const qs = projectId ? `?project_id=${projectId}` : '';
  return useSWR<Permission[]>(`/api/admin/permissions${qs}`, fetcher);
}

export async function createPermission(p: {
  project_id?: string | null;
  user_email?: string;
  group_name?: string;
  role: Permission['role'];
}): Promise<void> {
  const res = await fetch('/api/admin/permissions', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(p),
  });
  if (!res.ok) throw new Error(await res.text());
}

export async function deletePermission(id: string): Promise<void> {
  const res = await fetch(`/api/admin/permissions/${id}`, {
    method: 'DELETE',
    credentials: 'include',
  });
  if (!res.ok && res.status !== 204) throw new Error(`delete failed: ${res.status}`);
}
